module.exports = __webpack_public_path__ + "images/how-it-works-header@2x.fde196efcb887db249df3fc37ac5c7c9.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/how-it-works-header@2x.jpg
// module id = 1007
// module chunks = 0